import { useState } from 'react';
import { useProjects } from '../hooks/useProjects.js';
import ProjectColumn from './projects/ProjectColumn.jsx';
import ProjectDrawer from './projects/ProjectDrawer.jsx';

const COLUMNS = ['now', 'next', 'later', 'done'];

export default function Projects() {
  const { projects, loading, updateProject } = useProjects();
  const [selected, setSelected] = useState(null);
  const [dragging, setDragging] = useState(null);

  if (loading) {
    return <div className="text-center text-text-muted py-12">Loading…</div>;
  }

  function handleDropToColumn(id, columnKey) {
    // Always clear drag state — the source tile may have unmounted before
    // its native dragend could fire, leaving the new tile stuck dimmed.
    setDragging(null);
    const proj = projects.find((p) => p.id === id);
    if (!proj || proj.kanban_column === columnKey) return;
    updateProject(id, { kanban_column: columnKey });
  }

  function handleColumnChange(project, columnKey) {
    setDragging(null);
    if (project.kanban_column === columnKey) return;
    updateProject(project.id, { kanban_column: columnKey });
  }

  // If the drawer is open, keep its data fresh from the live projects list.
  const selectedLive = selected
    ? projects.find((p) => p.id === selected.id) || null
    : null;

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        {COLUMNS.map((col) => (
          <ProjectColumn
            key={col}
            columnKey={col}
            projects={projects.filter((p) => p.kanban_column === col)}
            draggingId={dragging?.id}
            onTileSelect={setSelected}
            onTileColumnChange={handleColumnChange}
            onTileDragStart={setDragging}
            onTileDragEnd={() => setDragging(null)}
            onDropToColumn={handleDropToColumn}
          />
        ))}
      </div>

      {selectedLive && (
        <ProjectDrawer
          project={selectedLive}
          onClose={() => setSelected(null)}
          onUpdate={updateProject}
        />
      )}
    </>
  );
}
